module.exports = __webpack_public_path__ + "static/media/Menu-Button.c18fc2c0.svg";